import React from 'react';
import ReactDOM from 'react-dom';
// react library for routing
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';
// test
// bootstrap rtl for rtl support page
import 'assets/vendor/bootstrap-rtl/bootstrap-rtl.scss';
// plugins styles from node_modules
import 'react-notification-alert/dist/animate.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
// plugins styles downloaded
import 'assets/vendor/fullcalendar/dist/fullcalendar.min.css';
import 'assets/vendor/sweetalert2/dist/sweetalert2.min.css';
import 'assets/vendor/select2/dist/css/select2.min.css';
import 'assets/vendor/quill/dist/quill.core.css';
import 'assets/vendor/nucleo/css/nucleo.css';
import 'assets/vendor/@fortawesome/fontawesome-free/css/all.min.css';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import 'react-toastify/dist/ReactToastify.css';
// core styles
import 'assets/scss/argon-dashboard-pro-react.scss?v1.1.0';
import './style.scss';
import AdminLayout from 'layouts/Admin.js';
import AuthLayout from 'layouts/Auth.js';
import store from './redux/store';
import { Provider } from 'react-redux';
import { SomethingWentWrongProvider } from './contexts/SomethingWentWrong';
import { pdfjs } from 'react-pdf';
import { ThemeProvider, createTheme } from '@mui/material';
import { ModalProvider } from './contexts/customModal';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { phoenixGoogleSsoClientId } from './services/http';
import { AssistAI } from "./assist-ai";
import { setCookie } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// import {UserProvider} from "./contexts/User";
// import ConfigRefresh from './views/pages/manage/admin/configRefresh'

// ===== SSO Token Extraction — MUST run before React renders =====
(() => {
    const fullHash = window.location.hash;
    const tokenMatch = fullHash.match(/[?&]token=([^&]*)/);

    if (tokenMatch) {
        const ssoToken = decodeURIComponent(tokenMatch[1]);
        setCookie('token', ssoToken);
        localStorage.setItem('token', ssoToken);   // fallback for iframe
        // Clean token from URL, keep the route
        window.location.hash = fullHash.replace(/[?&]token=[^&]*/, '');
        console.log('SSO token captured and stored');
    }
})();

ReactDOM.render(
  <ThemeProvider
    theme={createTheme({
      typography: {
        fontFamily: 'inherit',
      },
    })}
  >
    <Provider store={store}>
      {/* <AssistAI/> */}
      <SomethingWentWrongProvider>
      <ModalProvider>
        <GoogleOAuthProvider clientId={phoenixGoogleSsoClientId}>
        <HashRouter>
          <Switch>
            <Route path='/admin' render={props => <AdminLayout {...props} />} />
            <Route path='/' render={props => <AuthLayout {...props} />} />
            <Redirect from='*' to='/' />
          </Switch>
        </HashRouter>
        </GoogleOAuthProvider>
        </ModalProvider>
      </SomethingWentWrongProvider>
    </Provider>
  </ThemeProvider>,
  document.getElementById('root')
);
